import { Link } from 'react-router-dom';
import { categories, getCategoryById } from '@/mocks/categories';

interface ResourceCardProps {
  id: string;
  title: string;
  description: string;
  url: string;
  categoryId: string;
  tags: string[];
  isHot?: boolean;
  isNew?: boolean;
  icon: string;
}

export default function ResourceCard({
  id,
  title,
  description,
  url,
  categoryId,
  tags,
  isHot,
  isNew,
  icon,
}: ResourceCardProps) {
  const category = getCategoryById(categoryId);

  return (
    <div className="group bg-background-50 rounded-xl border border-background-200/70 p-5 hover:border-primary-200 transition-all duration-300 relative overflow-hidden">
      {isHot && (
        <span className="absolute top-3 right-3 px-2 py-0.5 bg-red-50 text-red-600 text-[10px] font-semibold rounded-full whitespace-nowrap">
          热门
        </span>
      )}
      {isNew && (
        <span className="absolute top-3 right-3 px-2 py-0.5 bg-accent-50 text-accent-700 text-[10px] font-semibold rounded-full whitespace-nowrap">
          新品
        </span>
      )}

      <div className="flex items-start gap-4">
        <div className="w-11 h-11 rounded-lg bg-primary-50 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-100 transition-colors">
          <i className={`${icon} text-lg text-primary-600`}></i>
        </div>
        <div className="flex-1 min-w-0">
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-foreground-900 font-semibold text-sm hover:text-primary-600 transition-colors block"
          >
            {title}
          </a>
          <p className="text-foreground-500 text-xs mt-1.5 line-clamp-2 leading-relaxed">
            {description}
          </p>
          <div className="flex items-center gap-2 mt-3 flex-wrap">
            {category && (
              <Link
                to={`/category/${category.slug}`}
                className="px-2 py-0.5 bg-secondary-50 text-secondary-700 text-[11px] rounded-md hover:bg-secondary-100 transition-colors whitespace-nowrap"
              >
                {category.name}
              </Link>
            )}
            {tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="text-foreground-400 text-[11px] whitespace-nowrap"
              >
                #{tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export function ResourceCardSlim({
  id,
  title,
  description,
  url,
  categoryId,
  icon,
}: ResourceCardProps) {
  const category = getCategoryById(categoryId);

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-3 px-4 py-3 bg-background-50 rounded-lg border border-background-200/60 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-200 group"
    >
      <div className="w-9 h-9 rounded-md bg-primary-50 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-100 transition-colors">
        <i className={`${icon} text-base text-primary-600`}></i>
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-foreground-900 font-medium text-sm group-hover:text-primary-600 transition-colors">
          {title}
        </div>
        <div className="text-foreground-400 text-xs truncate">{description}</div>
      </div>
      {category && (
        <span className="text-secondary-600 text-xs bg-secondary-50 px-2 py-0.5 rounded-md whitespace-nowrap">
          {category.name}
        </span>
      )}
    </a>
  );
}